<template>
    <div class="componentsCtn_1">
        <div class="top">
            我的报名
        </div>
        <div class="signUp_content">
            <div v-for="item in dataList" :key="item.id" class="signUp_item_banner">
                <table >
                    <tr style="font-size: 14px;color: #979797;font-weight: 400;height: 28px;">
                        <td width="425px" style="vertical-align: text-top">主题</td>
                        <td width="240px" style="vertical-align: text-top">提交时间</td>
                        <td width="150px" style="vertical-align: text-top">状态</td>
                        <td width="150px" style="vertical-align: text-top">操作</td>
                    </tr>
                    <tr style="height: 50px;font-size: 16px;" >
                        <td width="425px" style="vertical-align: text-top;width:425px;word-break: break-all;word-wrap:break-word;color: #3A3A3A;font-size: 16px;">
                            <span v-if="item.type=='0'">吉林一号遥感开发者培训班 (线上课堂)</span>
                            <span v-if="item.type=='1'">吉林一号遥感开发者线下集训营</span>
                            <span v-if="item.type=='2'">吉林一号遥感开发者培训班 (线上课堂-自主学习)</span>
                        </td>
                        <td style="vertical-align: text-top">
                            {{item.createTime}}
                        </td>
                        <td style="vertical-align: text-top">
                            <span v-if="item.status=='0'">未报名</span>
                            <span v-if="item.status=='1'">审核中</span>
                            <span v-if="item.status=='2'">报名成功</span>
                            <span v-if="item.status=='3'">报名未通过</span>
                        </td>
                        <td style="vertical-align: text-top;color: #C49760;">
                            <span  v-if="item.type=='0'&&item.status=='2'" @click="$router.push('/globalCourse')" style="cursor:pointer">进入课堂</span>
                            <span  v-if="item.type=='0'&&item.status=='3'" @click="$router.push({path:'/signInContent',query:{'type':1}});" style="cursor:pointer">重新报名</span>
                            <span  v-if="item.type=='0'&&item.status=='1'" @click="$router.push('/globalCourse')"  style="cursor:pointer">进入课堂</span>
                            <span @click="$router.push('/courseDetail')" v-if="item.type!='0'" style="cursor:pointer">活动详情</span>
                        </td>
                    </tr>

                </table>
            </div>


        </div>
    </div>

    
</template>

<script>
    export default {
        name: "SignUp",
        data(){
            return{
                dataList:[],

            }
        },
        methods:{
            getKey() {
                return localStorage.getItem("token");
            },
            getSignUpData:function () {
                let that=this
                this.axios
                    .get("/learn_back/course/register/queryCourseRegisterList", {
                        headers: {
                            Authorization: "Bearer " + this.getKey(),
                        },
                    }).then((response) => {
                    console.log('用户信息')
                    console.log(response)
                    if(response.status==200){
                        that.dataList=response.data.data
                    }
                })
            }


        },
        mounted(){
            this.getSignUpData();

        }
    }
</script>

<style scoped>
    .signUp_item_banner{
        width: 1032px;
        height: 122px;
        background: #F7F7F7;
        border-radius: 16px;
        margin-bottom: 20px;
        padding-top:31px;
        padding-left:39px;
    }
    .signUp_content{
        width: 100%;
        height: 576px;
        padding-left: 35px;
        overflow-y: auto;
    }
    /*滚动条样式*/
    .signUp_content::-webkit-scrollbar {
        width: 4px;
    }
    .signUp_content::-webkit-scrollbar-thumb {
        border-radius: 10px;
        box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        background: rgba(0,0,0,0.2);
    }
    .signUp_content::-webkit-scrollbar-track {
    }
    .top{
        height: 84px;
        line-height: 84px;
        padding-left: 35px;
        font-size: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #3A3A3A;
    }
    .componentsCtn_1{
        width: 100%;
        height: 660px;
        background: #FFFFFF;
        border-radius: 16px;
    }

</style>